import { render, staticRenderFns } from "./DataStoryIndex.vue?vue&type=template&id=53e0fb64&scoped=true&"
import script from "./DataStoryIndex.vue?vue&type=script&lang=js&"
export * from "./DataStoryIndex.vue?vue&type=script&lang=js&"
import style0 from "./DataStoryIndex.vue?vue&type=style&index=0&id=53e0fb64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e0fb64",
  null
  
)

export default component.exports